import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { EntidadesContext } from 'contexts/EntidadesContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { AuthContext } from 'contexts/AuthContext';
import { useModal } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import ResumoModal from 'components/Modals/ResumoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Filter from './filter';
import mock from './mock';

const Entidades = () => {
  const rotina = 'Entidades';
  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();
  const { user } = useContext(AuthContext);
  const { drops } = useContext(DropsContext);
  const { deleteGrid, exportPdf, exportXls } = useContext(GridContext);
  const { entidades, getEntidades, getLoading, putEntidadeStatus } =
    useContext(EntidadesContext);
  const { control, getValues, reset } = useForm({
    defaultValues: entidades?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getEntidades({ ...props, rotina, filter: getValues() });
  };

  const options = [
    {
      name: 'Adicionar',
      icon: 'add',
      action: () => navigate('/app/Entidades/Manutencao'),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: entidades?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: entidades?.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={entidades?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];
  const rowOptions = [
    {
      name: 'Análise',
      icon: 'query_stats',
      show: () => !user?.permissoes?.block_analise_entidade,
      action: ({ row }) => navigate(`/app/Entidades/Indicadores/${row?.id}`),
    },
    {
      name: 'Detalhes',
      icon: 'visibility',
      action: ({ row }) => navigate(`/app/Entidades/Detalhes/${row?.id}`),
    },
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row }) =>
        navigate('/app/Entidades/Manutencao', { state: { id: row?.id } }),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { rotina, id: row?.id },
                cb: () => {
                  loadGrid();
                  closeModal();
                },
              })
            }
          />
        ),
    },
    {
      name: 'Ativar',
      icon: 'key',
      menu: true,
      show: ({ row }) => row?.ativo !== 'SIM',
      action: ({ row }) => putEntidadeStatus({ id: row?.id, cb: loadGrid }),
    },
    {
      name: 'Inativar',
      icon: 'key_off',
      menu: true,
      show: ({ row }) => row?.ativo === 'SIM',
      action: ({ row }) => putEntidadeStatus({ id: row?.id, cb: loadGrid }),
    },
    {
      name: 'Permissões de Usuário',
      icon: 'manage_accounts',
      menu: true,
      show: ({ row }) =>
        row?.perfil?.includes('USUARIO') &&
        !user?.permissoes?.block_permissoes_usuario,
      action: ({ row }) =>
        navigate('/app/Entidades/Permissoes', { state: row }),
    },
    {
      name: 'Pessoal',
      icon: 'account_circle',
      menu: true,
      show: ({ row }) =>
        row?.perfil?.includes('FUNCIONARIO') &&
        user?.permissoes?.enable_pessoal,
      action: ({ row }) => navigate(`/app/Entidades/Pessoal/${row?.id}`),
    },
  ];

  const tabelas = [
    {
      name: 'Tipo de Documento',
      route: 'TipoDocumento',
    },
    {
      name: 'Tipo de Endereço',
      route: 'TipoEndereco',
    },
    {
      name: 'Tipo de Contato',
      route: 'TipoContato',
    },
    {
      name: 'Tipo de Vínculo',
      route: 'TipoVinculo',
    },
    {
      name: 'Atividade',
      route: 'AtividadeEntidade',
    },
    {
      name: 'Contribuinte',
      route: 'Contribuinte',
    },
    {
      name: 'Grupo',
      route: 'GrupoEntidade',
    },
    {
      name: 'Região',
      route: 'RegiaoEntidade',
    },
    {
      name: 'Cidade',
      route: 'Cidade',
    },
    {
      name: 'UF',
      route: 'UF',
    },
    {
      name: 'País',
      route: 'Pais',
    },
  ];

  return (
    <Container>
      <Header
        rotina={rotina}
        colunas={entidades?.colunas}
        tabelas={!user?.permissoes?.block_tabelas && tabelas}
      />
      <Card>
        <Grid
          grid={entidades}
          mock={mock}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={entidades} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default Entidades;
